<template>
    <section class="w-full flex flex-col gap-5">
      <!-- Première section (ROMAN PHOTO) -->
      <div class="hover:bg-gray-100 rounded-lg">
        <div class="flex justify-center flex-col items-center">
          <h1>ROMAN PHOTO</h1>
          <hr class="md:w-1/3 w-1/2 mt-5 rounded-lg border-1 mb-5 border-cv">
        </div>

        <div class="flex md:flex-row flex-col md:p-2 rounded-lg gap-2">
          <!-- Section de texte -->
          <div class="md:w-4/6 mb-4 md:mb-0">
            <div>
              <h1 class="font-bold text-4xl items-center flex justify-center mb-4">Brief</h1>
              <p>- Réaliser un roman photo sous forme de gaufrier à 9 vignettes
                <br> - Une thématique et des éléments imposés
              </p>
              <ul>
                <li>Le thème :</li>
                <ul>
                  <li><span class="ml-7 mr-3 text-2xl text-cv">•</span><span class="underline text-cv">Le polar</span></li>
                </ul>
              </ul>
              <ul>
                <li>Les 3 éléments :</li>
                <ul>
                  <li><span class="ml-7 mr-3 text-2xl text-cv">•</span><span class="underline text-cv">femme fatale, vol, épicerie</span></li>
                </ul>
              </ul>
              <div  class="flex flex-row items-center  mt-5">
                        <p><span class="font-bold">Logiciels mobilisés : </span></p>
                        <img class="h-10 ml-2 p-2  hover:bg-gray-300 rounded-lg" src="@/assets/IN.png" alt="">
                        <P>|</P>
                        <img class="h-10 p-2  hover:bg-gray-300 rounded-lg" src="@/assets/LR.png" alt="">

                    </div>
            </div>
          </div>
          

          <!-- Carrousel d'images pour ROMAN PHOTO -->
          <div class="relative flex flex-col items-center gap-2 mr-3">
            <div class="relative w-full max-w-md overflow-hidden">
              <button @click="prevSlide('roman')" class="absolute bg-black bg-opacity-50 backdrop-blur-xl left-0 top-1/2 transform -translate-y-1/2 text-white px-3 py-2 rounded-full">⬅</button>
               <img :src="imagesRoman[currentIndexRoman]" class="h-96 w-full object-cover rounded-lg" alt="Roman Photo">
              <button @click="nextSlide('roman')" class="absolute bg-black bg-opacity-50 backdrop-blur-xl right-0 top-1/2 transform -translate-y-1/2 text-white px-3 py-2 rounded-full">➡</button>
            </div>

            <div>
              <a href="/pdf/Projet-roman-photo.pdf" target="_blank" 
                class="py-2.5 px-6 text-sm rounded-full border border-solid border-cv text-cv cursor-pointer font-semibold text-center shadow-xs transition-all duration-500 hover:bg-cv hover:text-white">
                Voir le PDF
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-center my-5">
            <hr class="rounded-full md:w-1/3 w-1/2 mt-5 border-2 border-cv">
        </div>

      <div class="hover:bg-gray-100 rounded-lg">
        <div class="flex justify-center flex-col items-center">
          <h1>ATELIER EMILIE GEISSLER</h1>
          <hr class="md:w-1/3 w-1/2 mt-5 rounded-lg border-1 mb-5 border-cv">
        </div>

        <div class="flex md:flex-row flex-col md:p-2 rounded-lg gap-2">
          <!-- Section de texte -->
          <div class="md:w-4/6 mb-4 md:mb-0">
            <div>
              <h1 class="font-bold text-4xl items-center flex justify-center mb-4">Brief</h1>
              <p>- Proposer une nouvelle identité visuelle
                <br> - Restructurer la stratégie de communication de la marque
              </p>
              <ul>
                <li>Notre concept :</li>
                <ul>
                  <li><span class="ml-7 mr-3 text-2xl text-cv">•</span><span class="font-bold"><i>La délicatesse au service de l’Art</i></span></li>
                </ul>
              </ul>
              <ul>
                <li>Mots clés :</li>
                <ul>
                  <li><span class="ml-7 mr-3 text-2xl text-cv">•</span><span class="underline text-cv">Délicatesse, expertise, savoir-faire, luxe</span></li>
                </ul>
              </ul>
              <ul>
                <li>Notre positionnement :</li>
                <ul>
                  <li><span class="ml-7 mr-3 text-2xl text-cv">•</span><span class="font-bold"><i>« L’atelier de restauration d’art, à la fois digitalisé et délicat »</i></span></li>
                </ul>
              </ul>
              <div  class="flex flex-row items-center  mt-5">
                        <p><span class="font-bold">Logiciels mobilisés : </span></p>
                        <img class="h-10 ml-2 p-2  hover:bg-gray-300 rounded-lg" src="@/assets/IL.png" alt="">
                        <P>|</P>
                        <img class="h-10 p-2  hover:bg-gray-300 rounded-lg" src="@/assets/PS.png" alt="">

                    </div>
            </div>
          </div>
          

          <!-- Carrousel d'images pour ROMAN PHOTO -->
          <div class="relative flex flex-col items-center gap-2 mr-3">
            <div class="relative w-full max-w-lg overflow-hidden">
              <button @click="prevSlide('restauratrice')" class="absolute bg-black bg-opacity-50 backdrop-blur-xl left-0 top-1/2 transform -translate-y-1/2 text-white px-3 py-2 rounded-full">⬅</button>
              <img :src="imagesRestauratrice[currentIndexRestauratrice]" class="h-58 w-full object-cover rounded-lg" alt="Roman Photo">
              <button @click="nextSlide('restauratrice')" class="absolute bg-black bg-opacity-50 backdrop-blur-xl right-0 top-1/2 transform -translate-y-1/2 text-white px-3 py-2 rounded-full">➡</button>
            </div>

            <div>
              <a href="/pdf/Emilie-G.pdf" target="_blank" 
                class="py-2.5 px-6 text-sm rounded-full border border-solid border-cv text-cv cursor-pointer font-semibold text-center shadow-xs transition-all duration-500 hover:bg-cv hover:text-white">
                Voir le PDF
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-center my-5">
            <hr class="rounded-full md:w-1/3 w-1/2 mt-5 border-2 border-cv">
        </div>

      <!-- Deuxième section (MAGAZINE DE BASKET) -->
      <div class="hover:bg-gray-100 rounded-lg">
        <div class="flex justify-center flex-col items-center">
          <h1>MAGAZINE DE BASKET</h1>
          <hr class="md:w-1/3 w-1/2 mt-5 rounded-lg border-1 mb-5 border-cv">
        </div>

        <div class="flex md:flex-row flex-col md:p-2 rounded-lg gap-2">
          <!-- Section de texte -->
          <div class="md:w-4/6 mb-4 md:mb-0">
            <div>
              <h1 class="font-bold text-4xl items-center flex justify-center mb-4">Brief</h1>
              <p>- Créer une couverture et 2 pages de magazine sur un sport choisi.
                <br> - Intégration d'un faux texte 
              </p>
              <div  class="flex flex-row items-center  mt-5">
                        <p><span class="font-bold">Logiciels mobilisés : </span></p>
                        <img class="h-10 ml-2 p-2  hover:bg-gray-300 rounded-lg" src="@/assets/IN.png" alt="">
                        <P>|</P>
                        <img class="h-10 p-2  hover:bg-gray-300 rounded-lg" src="@/assets/PS.png" alt="">

                    </div>
            </div>
          </div>
          

          <!-- Carrousel d'images pour MAGAZINE BASKET -->
          <div class="relative flex flex-col items-center gap-2 mr-3">
            <div class="relative w-full max-w-md overflow-hidden">
              <button @click="prevSlide('basket')" class="absolute left-0 top-1/2 bg-black bg-opacity-50 backdrop-blur-xl transform -translate-y-1/2 text-white px-3 py-2 rounded-full">⬅</button>
              <img :src="imagesBasket[currentIndexBasket]" class="h-96 w-full object-cover rounded-lg" alt="Magazine Basket">
              <button @click="nextSlide('basket')" class="absolute text-white right-0 top-1/2 bg-black bg-opacity-50 backdrop-blur-xl transform -translate-y-1/2 text-white px-3 py-2 rounded-full">➡</button>
            </div>

            <div>
              <a href="/pdf/Emma-Nabyt-Ind.pdf" target="_blank" 
                class="py-2.5 px-6 text-sm rounded-full border border-solid border-cv text-cv cursor-pointer font-semibold text-center shadow-xs transition-all duration-500 hover:bg-cv hover:text-white">
                Voir le PDF
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-center my-5">
            <hr class="rounded-full md:w-1/3 w-1/2 mt-5 border-2 border-cv">
        </div>

      <!-- Deuxième section (MAGAZINE DE BASKET) -->
      <div class="hover:bg-gray-100 rounded-lg">
        <div class="flex justify-center flex-col items-center">
          <h1>REPRODUCTION PUB FANTA</h1>
          <hr class="md:w-1/3 w-1/2 mt-5 rounded-lg border-1 mb-5 border-cv">
        </div>

        <div class="flex md:flex-row flex-col md:p-2 rounded-lg gap-2">
          <!-- Section de texte -->
          <div class="md:w-4/6 mb-4 md:mb-0">
            <div>
              <h1 class="font-bold text-4xl items-center flex justify-center mb-4">Brief</h1>
              <p>-  Réaliser une affiche mettant en valeur la canette Fanta
                
              </p>
              <div  class="flex flex-row items-center  mt-5">
                        <p><span class="font-bold">Logiciels mobilisés : </span></p>
                        <img class="h-10 ml-2 p-2  hover:bg-gray-300 rounded-lg" src="@/assets/IL.png" alt="">
                        <P>|</P>
                        <img class="h-10 p-2  hover:bg-gray-300 rounded-lg" src="@/assets/PS.png" alt="">

                    </div>
            </div>
          </div>

          <!-- Carrousel d'images pour MAGAZINE BASKET -->
          <div class="relative flex flex-col items-center gap-2 mr-3">
            <div class="w-full max-w-md overflow-hidden">
              <img src="@/assets/photo-canette.png" class="h-96 w-full object-cover rounded-lg" alt="Magazine Basket">
            </div>

            
          </div>
        </div>
      </div>
    </section>
</template>

<script>
export default {
  data() {
    return {
      currentIndexRoman: 0, // Index du carrousel ROMAN PHOTO
      currentIndexBasket: 0, // Index du carrousel MAGAZINE BASKET
      currentIndexRestauratrice:0,
      
      // Images du carrousel ROMAN PHOTO
      imagesRoman: [
        require('@/assets/photo-roman.png'),
        require('@/assets/photo-roman1.png'),
        require('@/assets/photo-roman2.png'),
        require('@/assets/photo-roman3.png'),
        require('@/assets/photo-roman4.png'),
        require('@/assets/photo-roman5.png'),
        require('@/assets/photo-roman6.png'),
        require('@/assets/photo-roman7.png'),
        require('@/assets/photo-roman8.png'),
        require('@/assets/photo-roman9.png')
      ],

      // Images du carrousel MAGAZINE BASKET
      imagesBasket: [
        require('@/assets/crea-basket1.png'),
        require('@/assets/crea-basket2.png'),
        require('@/assets/crea-basket3.png')
        
      ],
      imagesRestauratrice: [
        require('@/assets/Photo-restauratrice1.png'),
        require('@/assets/Photo-restauratrice2.png'),
        require('@/assets/Photo-restauratrice3.png'),
        require('@/assets/Photo-restauratrice4.png'),
        require('@/assets/Photo-restauratrice5.png'),
        require('@/assets/Photo-restauratrice6.png'),
        require('@/assets/Photo-restauratrice7.png'),
        require('@/assets/Photo-restauratrice8.png'),
        require('@/assets/Photo-restauratrice9.png'),
        require('@/assets/Photo-restauratrice10.png')
      ],
    };
  },
  methods: {
    prevSlide(type) {
      if (type === 'roman') {
        this.currentIndexRoman = (this.currentIndexRoman === 0) ? this.imagesRoman.length - 1 : this.currentIndexRoman - 1;
      } else if (type === 'basket') {
        this.currentIndexBasket = (this.currentIndexBasket === 0) ? this.imagesBasket.length - 1 : this.currentIndexBasket - 1;
      }else if (type === 'restauratrice') {
        this.currentIndexRestauratrice = (this.currentIndexRestauratrice === 0) ? this.imagesRestauratrice.length - 1 : this.currentIndexRestauratrice - 1;
      }
    },
    nextSlide(type) {
      if (type === 'roman') {
        this.currentIndexRoman = (this.currentIndexRoman === this.imagesRoman.length - 1) ? 0 : this.currentIndexRoman + 1;
      } else if (type === 'basket') {
        this.currentIndexBasket = (this.currentIndexBasket === this.imagesBasket.length - 1) ? 0 : this.currentIndexBasket + 1;
      }
      else if (type === 'restauratrice') {
        this.currentIndexRestauratrice = (this.currentIndexRestauratrice === this.imagesRestauratrice.length - 1) ? 0 : this.currentIndexRestauratrice + 1;
      }
    }
  }
};
</script>

  
  <style>
  /* Styles pour les boutons du carrousel */
  button {
    transition: 0.3s ease-in-out;
  }

  </style>
  